import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin } from 'lucide-react';
import '../css/Footer.css';
import logoImage from '../assets/logo.png';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-content">
        {/* Left Section - Logo and Tagline */}
        <div className="footer-left">
          <div className="footer-logo-container">
            <a 
            href="/">
            <img src={logoImage} alt="Nimbli Logo" className="footer-logo"/>
            </a>
          </div>
          <p className="footer-tagline">Intelligence, on repeat</p>
        </div>

        {/* Center Section - Links */}
        <div className="footer-center">
          <div className="footer-links">
            <Link to="/about" className="footer-link">About Us</Link>
            <Link to="/faqs" className="footer-link">FAQs</Link>
            {/* <a href="#responsible-ai" className="footer-link">Responsible AI</a> */}
            {/* <Link to="/partners" className="footer-link">Our Partners</Link> */}
          </div>
        </div>

        {/* Right Section - Social */}
        <div className="footer-right">
          <a 
            href="https://www.linkedin.com/in/nimbli-marketing-122a7938a/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="footer-social-link"
            aria-label="LinkedIn"
          >
            <Linkedin size={24} />
          </a>
        </div>
      </div>

      {/* Bottom Section */}
      <div className="footer-bottom">
        <div className="footer-bottom-content">
          <p className="footer-copyright">
            ©{currentYear} Crikey Tech. All rights reserved.
          </p>
          <p className="footer-contact">
            <a href="/contact" className="footer-email">
              getintouch@crikeytech.com
            </a>
          </p>
          <div className="footer-legal">
            <a href="/privacy" className="footer-legal-link">Privacy Policy</a>
            <span className="footer-divider">|</span>
            <a href="/terms" className="footer-legal-link">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;